import { Table } from '@src/graphql-types'

export const createTableOptions = (
  tables: Pick<Table, 'id' | 'friendlyName'>[]
) => {
  const getTableType = (friendlyName: string) => {
    const trimmed = friendlyName.trim()

    // Check if number only, eg '4'
    if (/^\d+$/.test(trimmed)) {
      return { type: 'pure_numeric', number: parseInt(trimmed, 10), text: '' }
    }

    // Check if it contains numbers, ed 'Patio 4'
    const numberMatch = trimmed.match(/\d+/)
    if (numberMatch) {
      return {
        type: 'mixed',
        number: parseInt(numberMatch[0], 10),
        text: trimmed,
      }
    }

    // Else it's just alphabetical, eg 'Front Porch'
    return { type: 'alphabetical', number: null, text: trimmed }
  }

  const sortedTables = [...tables].sort((a, b) => {
    const aType = getTableType(a.friendlyName)
    const bType = getTableType(b.friendlyName)

    // Numbered tables only, come first
    if (aType.type === 'pure_numeric' && bType.type !== 'pure_numeric')
      return -1
    if (aType.type !== 'pure_numeric' && bType.type === 'pure_numeric') return 1

    // If both are number only, sort by number
    if (aType.type === 'pure_numeric' && bType.type === 'pure_numeric') {
      return aType.number! - bType.number!
    }

    // Mixed (Text and number) comes before pure alphabetical
    if (aType.type === 'mixed' && bType.type === 'alphabetical') return -1
    if (aType.type === 'alphabetical' && bType.type === 'mixed') return 1

    // If both are mixed, group alphabetically, the sort by number
    if (aType.type === 'mixed' && bType.type === 'mixed') {
      if (aType.text !== bType.text) {
        return aType.text.localeCompare(bType.text)
      }
      return aType.number! - bType.number!
    }

    // If both are alphabetical, sort alphabetically
    return a.friendlyName.localeCompare(b.friendlyName)
  })

  return sortedTables.map(table => ({
    value: table.id,
    name: table.friendlyName,
  }))
}
